import { Avatar, AvatarFallback, AvatarImage } from "@tellescope/ui";
import { formatName, formatInitials, formatPhone, cn } from "@tellescope/utils";
import { Check } from "lucide-react";
import type { Enduser } from "../types";

/**
 * Available default option renderer variants
 */
export type DefaultRendererVariant = "default" | "phone" | "email";

export interface DefaultEnduserOptionProps {
  enduser: Enduser;
  isSelected: boolean;
  variant: DefaultRendererVariant;
}

/**
 * Default option renderer for {@link EnduserSearchCombobox}: an avatar plus the enduser's name, with
 * an optional secondary line showing their phone or email depending on `variant`.
 */
export const DefaultEnduserOption = ({ enduser, isSelected, variant }: DefaultEnduserOptionProps) => (
  <>
    <div className="flex gap-2 items-center w-full">
      <Avatar className="h-8 w-8">
        <AvatarImage src={enduser.avatar} />
        <AvatarFallback>{formatInitials(enduser)}</AvatarFallback>
      </Avatar>
      <div className="flex flex-col min-w-0 flex-1">
        <p className="font-semibold text-sm truncate">{formatName(enduser)}</p>
        {variant === "phone" && enduser.phone && (
          <p className="text-xs text-muted-foreground truncate">{formatPhone(enduser.phone)}</p>
        )}
        {variant === "email" && enduser.email && (
          <p className="text-xs text-muted-foreground truncate">{enduser.email}</p>
        )}
      </div>
    </div>
    <Check className={cn("ml-2 h-4 w-4 shrink-0", isSelected ? "opacity-100" : "opacity-0")} />
  </>
);
